import { Box, Image, Stack, StackProps } from '@chakra-ui/react'
import { Body2, H5 } from 'components/typography'
import { FC } from 'react'

export interface DrQuoteSectionProps extends StackProps {
  quoteText: string
  doctorName: string
  credentials: string | string[]
  councilRegistryNo: string
  doctorImgSrc?: string
}

export const DrQuoteSection: FC<DrQuoteSectionProps> = ({
  quoteText,
  doctorName,
  credentials,
  councilRegistryNo,
  doctorImgSrc,
  ...props
}) => {
  return (
    <Stack py="1.5rem" pb={{ base: '4rem', lg: '5.5rem' }} bg="alabaster" alignItems="center" {...props}>
      <Stack direction={{ base: 'column', lg: 'row' }} maxW="912px" px="24px">
        <Stack
          borderRadius={{ base: '1.5rem', lg: '2.5rem' }}
          overflow="hidden"
          direction={{ base: 'column', lg: 'row-reverse' }}
          bg="grayscale.20"
        >
          <Image
            alt="médico"
            src={doctorImgSrc || '/landings/dermatology/aline.webp'}
            objectFit="cover"
            objectPosition="top"
            w={{ base: '100%', lg: '50%' }}
            maxH={{ base: '280px', lg: 'none' }}
          />

          <Stack
            justifyContent="space-between"
            p={{ base: '1.5rem', lg: '2.5rem' }}
            w={{ base: '100%', lg: '50%' }}
            spacing={{
              base: 4,
              lg: 12
            }}
          >
            <Stack>
              <H5>&ldquo;{quoteText}&rdquo;</H5>
            </Stack>

            <Box>
              <H5 mt="1rem" mb="12px">
                {doctorName}
              </H5>
              <Body2>{councilRegistryNo}</Body2>
              {Array.isArray(credentials) ? (
                credentials.map((line, index) => <Body2 key={index}>{line}</Body2>)
              ) : (
                <Body2>{credentials}</Body2>
              )}
            </Box>
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  )
}
